// extracted by mini-css-extract-plugin
export default {"team":"Team-module_team__psdri","contain":"Team-module_contain__hdnAd","header":"Team-module_header__skPWu","teamItems":"Team-module_teamItems__X2mb9"};